import { APIClient } from "api/api_helper";
import { PHARMACY_REPORTS_API } from "api/url_helper";

const api = new APIClient();

export const reportsSummaryApiService = {
  // GET SUBJECT WISE REPORT
  getSubjectWiseReport: (params: {
    studyid: number | string | null;
    searchtext?: string | null;
    pagesize?: number;
    currentpage?: number;
    status?: string | null;
    subjectno?: string | null;
    ipcategory?: string | null;
    actionname?: string | null;
    fromdate?: string | null;
    todate?: string | null;
    pagination?: boolean;
  }) => {
    const payload = {
      studyid: params.studyid,
      searchtext: params.searchtext || null,
      status: params.status || null,
      currentpage: params.currentpage || 1,
      pagesize: params.pagesize || 10,
      pagination: params.pagination || false,
      subjectno: params.subjectno || null,
      ipcategory: params.ipcategory || null,
      actionname: params.actionname || null,
      fromdate: params.fromdate || null,
      todate: params.todate || null,
    };
    return api.create(PHARMACY_REPORTS_API.REPORT + "SubjectWiseReport", payload);
  },

  // GET LEDGER REPORT
  getLedgerReport: (params: {
    studyid?: number | string | null;
    transactiontype?: string | null;
    fromdate?: string | null;
    todate?: string | null;
    searchtext?: string | null;
    status?: string | null;
    currentpage?: number;
    pagesize?: number;
    pagination?: boolean;
    ipcategory?: string | null;
  }) => {
    const payload = {
      studyid: params.studyid || null,
      transactiontype: params.transactiontype || null,
      fromdate: params.fromdate || null,
      todate: params.todate || null,
      searchtext: params.searchtext || null,
      status: params.status || null,
      currentpage: params.currentpage || 1,
      pagesize: params.pagesize || 10,
      pagination: params.pagination !== undefined ? params.pagination : true,
      ipcategory: params.ipcategory || null,
    };
    return api.create(PHARMACY_REPORTS_API.REPORT + "LedgerReport", payload);
  },

  //Get IP Reports 
  getSelectIpReports: (params: {
    studyid: number | string;
    searchtext: string | null;
    pagesize?: number;
    currentpage?: number;
    status?: string | null;
  }) => {
    const payload = {
      studyid: params.studyid,
      searchtext: params.searchtext,
      pagesize: params.pagesize || 10,
      currentpage: params.currentpage || 1,
      status: params.status,
    };
    return api.create(PHARMACY_REPORTS_API.REPORT + "IpReports", payload);
  },
};
